// extracted by mini-css-extract-plugin
module.exports = {"app":"AuthLayout_app__25Bn4","app-container":"AuthLayout_app-container__1WsVU","logo":"AuthLayout_logo__2iJrN","form-container":"AuthLayout_form-container__HzYSY"};